import { useEffect, useState } from 'react';

type WindowSize = {
  width: undefined | number;
  height: undefined | number;
  outerWidth: undefined | number;
  outerHeight: undefined | number;
};

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
    outerWidth: undefined,
    outerHeight: undefined,
  });

  useEffect(() => {
    // const updateVH = () => {
    //   let vh = window.innerHeight * 0.01;
    //   document.documentElement.style.setProperty('--vh', `${vh}px`);
    // };

    const changeWindowSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        // outerWidth: window.outerWidth,
        // outerHeight: window.outerHeight,
        outerWidth:
          document.querySelector('html')?.getBoundingClientRect().width ??
          window.outerWidth,
        outerHeight:
          document.querySelector('html')?.getBoundingClientRect().height ??
          window.outerHeight,
      });
      // updateVH();
    };

    changeWindowSize();

    window.addEventListener('resize', changeWindowSize);

    return () => {
      window.removeEventListener('resize', changeWindowSize);
    };
  }, []);

  return windowSize;
};

export default useWindowSize;
